import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	isAuthReady: false,
	userId: null,
	activeUser: {},
	adminDetails: {},
	alertMessage: null,
}

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		authReducer(state, action) {
			state.isAuthReady = true
			state.userId = action.payload
		},
		activeUserReducer(state, action) {
			state.activeUser = action.payload
		},
		adminReducer(state, action) {
			state.adminDetails = action.payload
		},
		signOutReducer(state) {
			state.activeUser = null
			state.userId = null
		},
		alertsReducer(state, action) {
			state.alertMessage = action.payload
		},
	},
})

export const {
	adminReducer,
	authReducer,
	signOutReducer,
	activeUserReducer,
	alertsReducer,
} = userSlice.actions

export default userSlice.reducer
